import request from "@/utils/request";
import { initGetParams } from "@/utils/index";



//获取企业信息
export function getEnterprise(data) {
  return request({
    url: `/credit/enterprise/2001006009`,
    method: "get",
  });
}


//修改企业信息
export function undateEnterprise(data) {
  return request({
    url: "/credit/enterprise/2001006008",
    method: "post",
    data: data,
  });
}

//修改手机信息
export function changePhone(data) {
  return request({
    url: "/credit/account/2001001010",
    method: "post",
    data: data,
  });
}
//获取验证码
export function getCode(data) {
  return request({
    url: `/credit/account/0000/getCode`,
    method: "get",
    params: data,
  });
}



//导出企业基础信息（Word转PDF，返回MinIO预览地址）
export function getBasicsExport(data) {
  return request({
    url: `/credit/enterprise/2001050004/exportForPdf`,
    method: "get",
    params: data,
    timeout: 180000, // LibreOffice转换最长120秒，覆盖默认60秒超时
  });
}


//导出企业详细信息（Word转PDF，返回MinIO预览地址）
export function getDetailsExport(data) {
  return request({
    url: `/credit/enterprise/2001050004/exportDetailForPdf`,
    method: "get",
    params: data,
    timeout: 180000,
  });
}

//企业门户端-工作台统计
export function getFinancialProduct(data) {
  return request({
    url: `/credit/financialProduct/2001046009`,
    method: "get",
    params: data,
  });
}




//信用评分-查询信用信息
export function getInformation(data) {
  return request({
    url: `/credit/creditScore/2001011004/details`,
    method: "get",
    params: data,
  });
}

//信用评分-新增/修改
export function addInformation(data) {
  return request({
    url: `/credit/creditScore/2001011001`,
    method: "post",
     data,
  });
}

//企业门户端-金融产品详情
export function getDetailPortal(data) {
  return request({
    url: `/credit/financialProduct/0000/detailPortal`,
    method: "get",
    params: data,
  });
}

export function cancelAproductOrder(data) {
  return request({
    url: `/credit/productOrder/2001048013`,
    method: "post",
    data,
  });
}

//企业确认授信通过/不通过
export function productOrder(data) {
  return request({
    url: `/credit/productOrder/2001048006`,
    method: "post",
    data,
  });
}
//企业门户端-金融产品详情
export function getDetailPortals(data) {
  return request({
    url: `/credit/productOrder/2001048009`,
    method: "get",
    params: data,
  });
}

//企业门户端-融资列表
export function getProductOrderList(data) {
  return request({
    url: `/credit/productOrder/2001048011`,
    method: "get",
    params: data,
  });
}



//企业门户端-融资列表
export function getFinancingNeedPage(data) {
  return request({
    url: `/credit/enterpriseFinancingNeed/2001051004`,
    method: "get",
    params: data,
  });
}

//我的融资需求新增
export function addFinancingNeed(data) {
  return request({
    url: `/credit/enterpriseFinancingNeed/2001051001`,
    method: "post",
    data,
  });
}


//我的融资需求删除
export function deleteFinancingNeed(data) {
  return request({
    url: `/credit/enterpriseFinancingNeed/2001051002`,
    method: "post",
    data,
  });
}

//我的融资需求修改
export function editorFinancingNeed(data) {
  return request({
    url: `/credit/enterpriseFinancingNeed/2001051003`,
    method: "post",
    data,
  });
}